import * as React from 'react';

export default function InstallmentsFilled({
  width = 24,
  height = 24,
  ...props
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 25 24"
      {...props}
    >
      <g clipPath="url(#a)">
        <path
          fill="#232D34"
          d="M12.113 5.38a3.376 3.376 0 0 1 5.172-2.609.374.374 0 0 1-.052.657 4.88 4.88 0 0 0-2.867 4.774.375.375 0 0 1-.563.353 3.375 3.375 0 0 1-1.69-3.176Zm10.492 9.677a2.295 2.295 0 0 1-1.276 2.063l-.04.018-3.641 1.551a.653.653 0 0 1-.112.038l-6 1.5a.744.744 0 0 1-.181.023h-9.75a1.5 1.5 0 0 1-1.5-1.5V15a1.5 1.5 0 0 1 1.5-1.5h2.69l2.12-2.121a2.982 2.982 0 0 1 2.121-.879h4.694a2.625 2.625 0 0 1 2.554 3.23l3.923-.902a2.308 2.308 0 0 1 2.898 2.23Zm-1.5 0a.807.807 0 0 0-1.02-.778l-.029.008-6.28 1.444a.776.776 0 0 1-.169.019h-3.002a.75.75 0 1 1 0-1.5h2.624a1.125 1.125 0 1 0 0-2.25H8.537a1.487 1.487 0 0 0-1.06.44l-2.122 2.12v4.19h5.907l5.853-1.463 3.562-1.517a.802.802 0 0 0 .429-.713Zm-5.25-7.182a3.375 3.375 0 1 0 6.749 0 3.375 3.375 0 0 0-6.75 0Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M.104 0h24v24h-24z" />
        </clipPath>
      </defs>
    </svg>
  );
}
